import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import AddressListModal from '../AddressListModal';
import { Box, Flex, Text } from 'core/ui/atoms';
import { ReactComponent as EditLine } from 'core/assets/images/V2/icons/EditLine.svg';
import useUser from 'core/hooks/useUser';

const BillingAddress = ({ title, edit = true }) => {
  const { currentUser } = useUser();
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const handleCloseAddressModal = () => setOpenAddressModal(false);

  const { primaryAddress, firstName, lastName } = currentUser;
  const { street1, street2, city, state, zipCode } = primaryAddress;

  return (
    <CustomBox $edit={edit}>
      <Flex justifyContent='space-around'>
        <AddressContainer>
          {title && <HeaderText>{title}</HeaderText>}
          <AddressText>{`${firstName} ${lastName}`}</AddressText>
          <AddressText>{street1}{' '}{street2}</AddressText>
          <AddressText>{`${city}, ${state}, ${zipCode} US`}</AddressText>
        </AddressContainer>
        {edit && <EditIcon onClick={() => setOpenAddressModal(true) } />}
      </Flex>
      {openAddressModal && <AddressListModal closeModal={handleCloseAddressModal} />}
    </CustomBox>
  );
};

BillingAddress.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
};

const EditIcon = styled(EditLine)`
  cursor: pointer;
`;

const CustomBox = styled(Box)`
  width: 100%;
  padding-bottom: 20px;
`;

const AddressContainer = styled(Box)`
  width: ${({ $edit }) => $edit ? '90%' : '100%' }
`;

const AddressText = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0%;
  margin: 2px;
`;

const HeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  line-height: 22px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export default BillingAddress;
